import SsoUser from './sso_fetch_user';
import { writeCookie } from '../helpers/cookie';
import { primaryLoginMethods, realms } from '../shared/constants';
import * as CreateAccountRules from '../components/utils/FormValidationRules';
import { getEmailValidationErrorStringKey } from '../helpers/form_helper';

export function setTimestampCookie(domain) {
  const currentTime = Date.now();
  writeCookie('info_idp_vat_time', currentTime, domain);
}

export function crossOriginLogin({ jwt, app, host, globals = { version: '', realm: '', url_params: {} } }) {
  const sso_user = new SsoUser(host, globals.version);
  return sso_user.cross_origin_login(jwt, app, globals);
}

export async function login({
  email,
  globals = { realm: '', plid: '', host: '', url_params: {} },
  username,
  password,
  remember_me,
  link_account,
  login_method,
  primaryLoginId,
  allowShopperIdAsLoginId = false,
}) {
  const field_errors = {};
  if (primaryLoginId === primaryLoginMethods.USERNAME && !username) {
    field_errors.username = 'USERNAME_REQUIRED';
  } else if (primaryLoginId === primaryLoginMethods.EMAIL_ADDRESS) {
    if (!email) {
      field_errors.email = 'EMPTY_REQUIRED_FIELD';
    } else if (
      allowShopperIdAsLoginId
        ? !(CreateAccountRules.ContainOnlyNumbersRule(email) || CreateAccountRules.EmailFormatRule(email))
        : !CreateAccountRules.EmailFormatRule(email)
    ) {
      field_errors.email = getEmailValidationErrorStringKey(globals, allowShopperIdAsLoginId);
    }
  }

  if (!password) {
    field_errors.password = 'PASSWORD_REQUIRED';
  }

  if (field_errors.email || field_errors.username || field_errors.password) {
    return Promise.reject({ data: { type: 'SET_ERRORS', errors: field_errors } });
  }

  const sso_user = new SsoUser(globals.host, globals.version);
  let response = await sso_user.login(username, password, remember_me, globals, link_account, email, login_method);
  const { jwt, app, host } = response.data;

  if (jwt) {
    const crossOriginLoginArgs = { jwt, app, host, globals, remember_me };
    response = await crossOriginLogin(crossOriginLoginArgs);
  } else if (globals.realm === realms.IDP) {
    setTimestampCookie(globals.host);
  }

  return response;
}
